import { Record } from 'immutable';

const AreaOfInnovationRecord = Record({
  id: null,
  name: '',
});

class AreaOfInnovation extends AreaOfInnovationRecord {
  get id() {
    return this.get('id');
  }

  get name() {
    return this.get('name');
  }
}

export default AreaOfInnovation;
